export default __webpack_public_path__ + "static/media/Preferences.f7b55077.svg";